import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import { darkTheme } from '@/contexts/theme/monitoringTool.theme';

export const LightDivider = styled(Divider)(() => ({
  borderColor: darkTheme.palette.divider,
}));
